// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OYKG","content":"styles_content__1I1s6"};